import { useMemo } from "react";
import { useIntl } from "react-intl";
import { ConductTypes } from "~enums/conductTypes.ts";
import { sortStringValues } from "~utils/utilities.ts";

export const useGetConductTypeOptions = () => {
  const { formatMessage } = useIntl();

  return useMemo(
    () =>
      Object.values(ConductTypes)
        .map((value) => ({ value, label: formatMessage({ id: `conductType.${value}` }) }))
        .sort((first, second) => sortStringValues(first.label, second.label)),
    [formatMessage],
  );
};
